import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["configInput", "instanceInput", "instanceContainer", "selectConfigMessageContainer", "selectInstanceContainer"]

  @values =
    configurations: Array
    instances: Array
    editMode: Boolean

  connect: ->
    @initConfigTokenfield()

  initConfigTokenfield: ->
    configData = @configurationsValue.map (c) -> { value: c.id, label: c.name }

    # Initialize the tokenfield.
    $config = $(@configInputTarget)
    $config.tokenfield(
      autocomplete:
        source: configData
        delay: 100
      showAutocompleteOnFocus: true
      limit: 1
    )

    $config.on "tokenfield:createtoken", (e) =>
      selected = @configurationsValue.find (c) -> c.id == parseInt(e.attrs.value)
      @selectInstanceContainerTarget.hidden = false
      @selectConfigMessageContainerTarget.hidden = true
      @setupInstanceOptions(selected.id)

    $config.on "tokenfield:removedtoken", =>
      @selectInstanceContainerTarget.hidden = true
      @selectConfigMessageContainerTarget.hidden = false
      @disableAndClearInstance()

    # Find the selected config (There may not be one)
    selectedConfigToken = configData.find (c) => c.value == parseInt(@configInputTarget.value)
    if selectedConfigToken
      $config.tokenfield('setTokens', [selectedConfigToken])
    else
      @selectInstanceContainerTarget.hidden = true
      @selectConfigMessageContainerTarget.hidden = false

  setupInstanceOptions: (configId) ->
    relevant = @instancesValue.filter (i) -> i.configuration_id == configId

    existingIds = (@instanceInputTarget.value || '').split(',')
      .map((id) -> parseInt(id.trim()))
      .filter((id) -> !isNaN(id) && id > 0)

    container = @instanceContainerTarget
    container.innerHTML = ''

    inputType = if @editModeValue then 'radio' else 'checkbox'

    relevant.forEach (instance) =>
      input = document.createElement('input')
      input.type    = inputType
      input.value   = instance.id
      input.id      = "newsletter_instance_#{instance.id}"
      input.name    = "newsletter_instance" # A common name for when the rendered input is a radio.
      input.checked = existingIds.includes(instance.id)
      input.addEventListener 'change', => @syncInstanceInput()
      input.setAttribute("data-toggle-all-target", "checkbox")

      labelText = document.createElement('span')
      labelText.textContent = instance.name

      label = document.createElement('label')
      label.htmlFor     = input.id
      label.appendChild(input)
      label.appendChild(labelText)

      wrapper = document.createElement('div')
      wrapper.className = inputType
      wrapper.appendChild(label)
      container.appendChild(wrapper)

  syncInstanceInput: ->
    checked = @instanceContainerTarget.querySelectorAll('input:checked')
    @instanceInputTarget.value = Array.from(checked).map((i) -> i.value).join(',')

  disableAndClearInstance: ->
    @instanceContainerTarget.innerHTML = ''
    @instanceInputTarget.value = ''
